import { Component } from '@grafikr/components';

import initMegaMenu from './parts/mega-menu';
import initMobileMenu from './parts/mobile-menu';
import initSearch from './parts/search';

export default Component((node, { app }) => {
  const CLASSES = {
    HEADER_OVERLAY_ACTIVE: 'header--has-overlay',
  };

  initMegaMenu(node, CLASSES);
  initMobileMenu(node, CLASSES, app);
  initSearch(node, CLASSES, app);
});
